import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=61de2c8a&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61de2c8a')) {
      api.createRecord('61de2c8a', component.options)
    } else {
      api.reload('61de2c8a', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=61de2c8a&", function () {
      api.rerender('61de2c8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20PG6paUVJ6g1/JS/comp/ErrorMessage.vue"
export default component.exports